import {JourneyStatusBadge} from '@/components/JourneyStatusBadge/JourneyStatusBadge'
import type {IDataTableProps} from 'pepsico-ds'
import {CSSProperties} from 'react'
import {IntlFormatters} from 'react-intl'
import {JourneyListItem} from '../../../types/Journeys'
import {DatetimeCell, JourneyDescriptionCell, JourneyNameCell, JourneyTypeCell, PublishedByCell} from './CustomCells'

// kept for shared-components/DataTable which imports this type
export type CustomColumnMeta = {
  styles?: CSSProperties
}

export const getTableColumns = (
  formatMessage: IntlFormatters['formatMessage']
): IDataTableProps<JourneyListItem>['columns'] => [
  {
    columnKey: 'name',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_NAME_COLUMN'}),
    filterVariant: 'text',
    enableSorting: true,
    initialSize: 200,
    cellData: ({row}) => <JourneyNameCell name={row.original.name} id={row.original.id} />,
  },
  {
    columnKey: 'type',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_TYPE_COLUMN'}),
    filterVariant: 'dropdown',
    dropdownFilterOptions: {selection: 'single'},
    enableSorting: true,
    initialSize: 100,
    cellData: ({row}) => <JourneyTypeCell type={row.original.type} />,
  },
  {
    columnKey: 'description',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_DESCR_COLUMN'}),
    filterVariant: 'text',
    enableSorting: false,
    initialSize: 300,
    cellData: ({row}) => <JourneyDescriptionCell description={row.original.description ?? ''} />,
  },
  {
    columnKey: 'status',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_STATUS_COLUMN'}),
    filterVariant: 'dropdown',
    dropdownFilterOptions: {selection: 'single'},
    enableSorting: true,
    initialSize: 150,
    cellData: ({row}) => <JourneyStatusBadge status={row.original.status} />,
  },
  {
    columnKey: 'createdAt',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_CREATED_AT_COLUMN'}),
    filterVariant: 'dateRange',
    enableSorting: true,
    initialSize: 180,
    cellData: ({row}) => <DatetimeCell value={row.original.createdAt} />,
  },
  {
    columnKey: 'updatedAt',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_MODIFIED_AT_COLUMN'}),
    filterVariant: 'dateRange',
    enableSorting: true,
    initialSize: 180,
    cellData: ({row}) => <DatetimeCell value={row.original.updatedAt ?? undefined} />,
  },
  {
    columnKey: 'publishedAt',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_PUBLISHED_AT_COLUMN'}),
    filterVariant: 'dateRange',
    enableSorting: true,
    initialSize: 180,
    cellData: ({row}) => <DatetimeCell value={row.original.publishedAt ?? undefined} />,
  },
  {
    columnKey: 'country',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_COUNTRY_COLUMN'}),
    enableSorting: false,
    initialSize: 80,
    cellData: ({row}) => <div className="text-sm">{row.original.country}</div>,
  },
  {
    columnKey: 'publishedBy',
    header: formatMessage({id: 'JOURNEY_LIST.TABLE_PUBLISHED_BY_COLUMN'}),
    filterVariant: 'text',
    enableSorting: false,
    initialSize: 200,
    maxSize: 300,
    cellData: ({row}) => <PublishedByCell value={row.original.publishedBy ?? undefined} />,
  },
]
